<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>
    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">{{ operacion() }}Servicio</h1>
    </div>
  </div>

  <div class="row-cols-12 m-2 mt-0">
    <div class="row p-3 mb-0 align-items-center">
      <div class="mb-3 mt-0 text-start">
        <form (ngSubmit)="saveServicio()" [formGroup]="myAccountServicio">

          <div class="mb-0 mt-2 text-start">
            <label for="especialidadSearch" class="form-label"><b>Especialidad</b></label>

            <div class="search-select mb-3">
              <input
                type="search"
                id="especialidadSearch"
                class="form-control search-select-input"
                placeholder="Buscar especialidad"
                [value]="especialidadSearch()"
                (focus)="showEspecialidadesList.set(true)"
                (input)="onEspecialidadInput($any($event.target).value)"
              />

              @if (showEspecialidadesList()) {
                <div class="search-select-list">
                  @for (esp of especialidadesFiltradas(); track esp.id) {
                    <button
                      type="button"
                      class="search-select-item"
                      (click)="selectEspecialidad(esp)"
                    >
                      <span>{{ esp.x_descripcion }}</span>
                      <i class="bi bi-chevron-right"></i>
                    </button>
                  }

                  @if (especialidadesFiltradas().length === 0) {
                    <div class="search-select-empty">
                      No se encontraron especialidades
                    </div>
                  }
                </div>
              }
            </div>

            <input type="hidden" formControlName="especialidad" />

            <div class="d-flex justify-content-between align-items-center">
              <label class="form-label mb-0">
                <b>{{ esAgregarMultiple ? 'Prestaciones' : 'Prestación' }}</b>
              </label>

              @if (esAgregarMultiple && prestacionesDisponibles().length > 0) {
                <button
                  type="button"
                  class="btn-select-all"
                  (click)="toggleSeleccionarTodasLasPrestaciones()"
                >
                  {{ prestacionesSeleccionadas().length === prestacionesDisponibles().length ? 'Quitar todas' : 'Seleccionar todas' }}
                </button>
              }
            </div>

            @if (prestacionesDisponibles().length === 0) {
              <div class="text-muted small mb-3 mt-1">
                Seleccioná una especialidad para ver las prestaciones disponibles.
              </div>
            } @else {
              <div class="search-select-list mb-1 mt-1">
                @for (pre of prestacionesDisponibles(); track pre.id) {
                  <button
                    type="button"
                    class="search-select-item"
                    [class.selected]="isPrestacionSelected(pre.id!)"
                    (click)="togglePrestacion(pre.id!)"
                  >
                    <span>{{ pre.x_descripcion }}</span>
                    <i class="bi" [class.bi-check-circle-fill]="isPrestacionSelected(pre.id!)" [class.bi-circle]="!isPrestacionSelected(pre.id!)"></i>
                  </button>
                }
              </div>

              @if (esAgregarMultiple) {
                <div class="text-muted small mb-3">
                  {{ prestacionesSeleccionadas().length }} prestación(es) seleccionada(s)
                </div>
              } @else {
                <div class="mb-3"></div>
              }
            }
          </div>

          <div class="mb-4 mt-0 text-start small text-muted">
            * Si no encuentra la especialidad o prestacíon puede solicitar el alta
            <a [routerLink]="['/solicitud-especialidad-prestacion']"><strong>aquí</strong></a>
          </div>

          @if (myAccountServicio.controls.especialidad.invalid &&
               (myAccountServicio.controls.especialidad.dirty || myAccountServicio.controls.especialidad.touched)) {
            <div class="alert-danger" role="alert">
              <small class="alert">Debe seleccionar una Especialidad</small>
            </div>
          }

          @if (intentoEnviar() && prestacionesSeleccionadas().length === 0) {
            <div class="alert-danger" role="alert">
              <small class="alert">Debe seleccionar al menos una prestación</small>
            </div>
          }

          <div class="mb-4 mt-2 text-start">
            <label for="descripcion" class="form-label"><b>Descripción del servicio</b></label>
            <input
              type="text"
              class="form-control"
              id="descripcion"
              formControlName="descripcion"
              placeholder="Ingrese una descripción"
            />

            @if (myAccountServicio.controls.descripcion.invalid &&
                 (myAccountServicio.controls.descripcion.dirty || myAccountServicio.controls.descripcion.touched) &&
                 myAccountServicio.controls.descripcion.errors?.['required']) {
              <div class="alert-danger" role="alert">
                <small class="alert">La descripción es requerida</small>
              </div>
            }
          </div>

          @if (error(); as err) {
            @if (err.length > 0) {
              <div class="alert alert-danger mt-2" role="alert">
                <small>{{ err }}</small>
              </div>
            }
          }

          <div class="d-grid mt-5 mb-3 pb-3">
            <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading()">
              {{ loading() ? 'Cargando...' : botonLabel() }}
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>
